import request from '../utils/request';

export function getStoreList(param) {
    return request({
        url: '/admin/search-store',
        method: 'GET',
        params: param
    })
}

export function saveStore(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/store',
            method: 'POST',
            data
        })
    }
    return request({
        url: '/admin/store/'+id,
        method: 'PUT',
        data
    })
}

export function deleteStore(id) {
    return request({
        url: '/admin/store/'+id,
        method: 'DELETE'
    })
}

export function setStoreSort(id, sort) {
    return request({
        url: '/admin/store/'+id+'/sort/'+sort,
        method: 'PUT'
    })
}

export function setStoreIsvalidate(id, isvalidate) {
    return request({
        url: '/admin/store/'+id+'/is-validate/'+isvalidate,
        method: 'PUT'
    })
}

export function getStoreOption(id) {
    return request({
        url: '/admin/store-option?area_id='+id,
        method: 'GET'
    })
}

export function getStoreDetail(id) {
    return request({
        url: '/admin/store-info/' + id,
        method: 'GET'
    })
}

export function getAreaOption() {
    return request({
        url: '/admin/area-config',
        method: 'GET'
    })
}
export function getManagerOption(param) {
    return request({
        url: '/admin/search-manager',
        method: 'GET',
        params:param
    })
}

export function getStoreOpenTime(id) {
    return request({
        url: '/admin/store/'+id+'/open-time',
        method: 'GET'
    })
}

export function saveStoreOpenTime(id,data){
    return request({
        url: '/admin/store/'+id+'/open-time',
        method: 'PUT',
        data
    })
}

// 获取所有加盟商
export function getFranchisee(){
    return request({
        url: '/admin/company-option',
        method: 'GET'
    })
}